const ioc = [{
	id: '55', value: 'AFG', text: 'Afghanistan', idArea: '5',
},
{
	id: '231', value: 'AHO', text: 'Niederländische Antillen', idArea: '2',
},
{
	id: '300', value: 'AIA', text: 'Anguilla', idArea: '2',
},
{
	id: '131', value: 'ALB', text: 'Albanien', idArea: '1',
},
{
	id: '130', value: 'ALG', text: 'Algerien', idArea: '4',
},
{
	id: '301', value: 'ANA', text: 'Athleten unter neutraler Flagge', idArea: '0',
},
{
	id: '128', value: 'AND', text: 'Andorra', idArea: '1',
},
{
	id: '127', value: 'ANG', text: 'Angola', idArea: '4',
},
{
	id: '126', value: 'ANT', text: 'Antigua und Barbuda', idArea: '2',
},
{
	id: '125', value: 'ARG', text: 'Argentinen', idArea: '3',
},
{
	id: '42', value: 'ARM', text: 'Armenien', idArea: '1',
},
{
	id: '124', value: 'ARU', text: 'Aruba', idArea: '2',
},
{
	id: '129', value: 'ASA', text: 'Amerikanisch Samoa', idArea: '6',
},
{
	id: '113', value: 'AUS', text: 'Australien', idArea: '6',
},
{
	id: '1', value: 'AUT', text: 'Österreich', idArea: '1',
},
{
	id: '122', value: 'AZE', text: 'Aserbaidschan', idArea: '1',
},
{
	id: '132', value: 'BAH', text: 'Bahamas', idArea: '2',
},
{
	id: '119', value: 'BAN', text: 'Bangladesh', idArea: '5',
},
{
	id: '118', value: 'BAR', text: 'Barbados', idArea: '2',
},
{
	id: '146', value: 'BDI', text: 'Burundi', idArea: '4',
},
{
	id: '63', value: 'BEL', text: 'Belgien', idArea: '1',
},
{
	id: '114', value: 'BEN', text: 'Benin', idArea: '4',
},
{
	id: '115', value: 'BER', text: 'Bermuda', idArea: '2',
},
{
	id: '142', value: 'BHU', text: 'Bhutan', idArea: '5',
},
{
	id: '8', value: 'BIH', text: 'Bosnien Herzegovina', idArea: '1',
},
{
	id: '123', value: 'BIH', text: 'Bosnien Herzegovina', idArea: '1',
},
{
	id: '116', value: 'BIZ', text: 'Belize', idArea: '2',
},
{
	id: '117', value: 'BLR', text: 'Weisrussland', idArea: '1',
},
{
	id: '144', value: 'BOL', text: 'Bolivien', idArea: '3',
},
{
	id: '152', value: 'BOT', text: 'Botswana', idArea: '4',
},
{
	id: '151', value: 'BRA', text: 'Brasilien', idArea: '3',
},
{
	id: '120', value: 'BRN', text: 'Bahrain', idArea: '5',
},
{
	id: '148', value: 'BRU', text: 'Brunei', idArea: '5',
},
{
	id: '20', value: 'BUL', text: 'Bulgarien', idArea: '1',
},
{
	id: '147', value: 'BUR', text: 'Burkina Faso', idArea: '4',
},
{
	id: '141', value: 'CAF', text: 'Zentralafrikanische Republik', idArea: '4',
},
{
	id: '145', value: 'CAM', text: 'Kambotscha', idArea: '5',
},
{
	id: '67', value: 'CAN', text: 'Kanada', idArea: '2',
},
{
	id: '154', value: 'CAY', text: 'Cayman Islands', idArea: '2',
},
{
	id: '135', value: 'CGO', text: 'Republik Kongo', idArea: '4',
},
{
	id: '140', value: 'CHA', text: 'Tschad', idArea: '4',
},
{
	id: '139', value: 'CHI', text: 'Chile', idArea: '3',
},
{
	id: '138', value: 'CHN', text: 'China', idArea: '5',
},
{
	id: '92', value: 'CIV', text: 'Cote d Ivoire', idArea: '4',
},
{
	id: '133', value: 'CMR', text: 'Kamerun', idArea: '4',
},
{
	id: '103', value: 'COD', text: 'Kongo', idArea: '4',
},
{
	id: '153', value: 'COK', text: 'Cook Islands', idArea: '6',
},
{
	id: '137', value: 'COL', text: 'Kolumbien', idArea: '3',
},
{
	id: '136', value: 'COM', text: 'Komoren', idArea: '4',
},
{
	id: '143', value: 'CPV', text: 'Kapverden', idArea: '4',
},
{
	id: '121', value: 'CRC', text: 'Costa Rica', idArea: '2',
},
{
	id: '26', value: 'CRO', text: 'Kroatien', idArea: '1',
},
{
	id: '15', value: 'CUB', text: 'Kuba', idArea: '2',
},
{
	id: '91', value: 'CYP', text: 'Zypern', idArea: '1',
},
{
	id: '10', value: 'CZE', text: 'Tschechien', idArea: '1',
},
{
	id: '59', value: 'DEN', text: 'Dänemark', idArea: '1',
},
{
	id: '90', value: 'DJI', text: 'Djibouti', idArea: '4',
},
{
	id: '89', value: 'DMA', text: 'Dominica', idArea: '2',
},
{
	id: '88', value: 'DOM', text: 'Domänikanische Republik', idArea: '2',
},
{
	id: '87', value: 'ECU', text: 'Ecuador', idArea: '3',
},
{
	id: '86', value: 'EGY', text: 'Ägypten', idArea: '4',
},
{
	id: '83', value: 'ERI', text: 'Eritrea', idArea: '4',
},
{
	id: '85', value: 'ESA', text: 'El Salvador', idArea: '2',
},
{
	id: '159', value: 'ESP', text: 'Spanien', idArea: '1',
},
{
	id: '93', value: 'EST', text: 'Estland', idArea: '1',
},
{
	id: '81', value: 'ETH', text: 'Äthiopien', idArea: '4',
},
{
	id: '80', value: 'FIJ', text: 'Fiji', idArea: '6',
},
{
	id: '79', value: 'FIN', text: 'Finnland', idArea: '1',
},
{
	id: '34', value: 'FRA', text: 'Frankreich', idArea: '1',
},
{
	id: '199', value: 'FSM', text: 'Micronesien', idArea: '6',
},
{
	id: '78', value: 'GAB', text: 'Gabun', idArea: '4',
},
{
	id: '77', value: 'GAM', text: 'Gambia', idArea: '4',
},
{
	id: '60', value: 'GBR', text: 'Großbritannien', idArea: '1',
},
{
	id: '109', value: 'GBS', text: 'Guinea-Bissau', idArea: '4',
},
{
	id: '76', value: 'GEO', text: 'Georgien', idArea: '1',
},
{
	id: '74', value: 'GEQ', text: 'Äquatorial Guinea', idArea: '4',
},
{
	id: '2', value: 'GER', text: 'Deutschland', idArea: '1',
},
{
	id: '82', value: 'GHA', text: 'Ghana', idArea: '4',
},
{
	id: '262', value: 'GRE', text: 'Griechenland', idArea: '1',
},
{
	id: '38', value: 'GRE', text: 'Griechenland', idArea: '1',
},
{
	id: '186', value: 'GRN', text: 'Grenada', idArea: '2',
},
{
	id: '134', value: 'GUA', text: 'Guatemala', idArea: '2',
},
{
	id: '110', value: 'GUI', text: 'Guinea', idArea: '4',
},
{
	id: '84', value: 'GUM', text: 'Guam', idArea: '6',
},
{
	id: '108', value: 'GUY', text: 'Guyana', idArea: '3',
},
{
	id: '107', value: 'HAI', text: 'Haiti', idArea: '2',
},
{
	id: '105', value: 'HKG', text: 'Hong Kong', idArea: '5',
},
{
	id: '106', value: 'HON', text: 'Honduras', idArea: '2',
},
{
	id: '280', value: 'HUN', text: 'Ungarn', idArea: '1',
},
{
	id: '19', value: 'HUN', text: 'Ungarn', idArea: '1',
},
{
	id: '94', value: 'INA', text: 'Indonesien', idArea: '5',
},
{
	id: '58', value: 'IND', text: 'Indien', idArea: '5',
},
{
	id: '102', value: 'IRI', text: 'Iran', idArea: '5',
},
{
	id: '62', value: 'IRL', text: 'Irland', idArea: '1',
},
{
	id: '112', value: 'IRQ', text: 'Irak', idArea: '5',
},
{
	id: '104', value: 'ISL', text: 'Island', idArea: '1',
},
{
	id: '101', value: 'ISR', text: 'Israel', idArea: '1',
},
{
	id: '304', value: 'ISV', text: 'Amerikanische Jungferninseln', idArea: '2',
},
{
	id: '37', value: 'ITA', text: 'Italien', idArea: '1',
},
{
	id: '150', value: 'IVB', text: 'British Virgin Islands', idArea: '2',
},
{
	id: '100', value: 'JAM', text: 'Jamaica', idArea: '2',
},
{
	id: '99', value: 'JOR', text: 'Jordanien', idArea: '5',
},
{
	id: '9', value: 'JPN', text: 'Japan', idArea: '5',
},
{
	id: '98', value: 'KAZ', text: 'Kasachstan', idArea: '5',
},
{
	id: '97', value: 'KEN', text: 'Kenya', idArea: '4',
},
{
	id: '75', value: 'KGZ', text: 'Kirgistan', idArea: '6',
},
{
	id: '50', value: 'KOR', text: 'Süd Korea', idArea: '5',
},
{
	id: '305', value: 'KOS', text: 'Kosovo', idArea: '1',
},
{
	id: '166', value: 'KSA', text: 'Saudiarabien', idArea: '5',
},
{
	id: '95', value: 'KUW', text: 'Kuwait', idArea: '5',
},
{
	id: '156', value: 'LAO', text: 'Laos', idArea: '5',
},
{
	id: '214', value: 'LAT', text: 'Lettland', idArea: '1',
},
{
	id: '211', value: 'LBA', text: 'Libyen', idArea: '4',
},
{
	id: '32', value: 'LBR', text: 'Liberia', idArea: '4',
},
{
	id: '171', value: 'LCA', text: 'St. Lucia', idArea: '2',
},
{
	id: '212', value: 'LES', text: 'Lesotho', idArea: '4',
},
{
	id: '207', value: 'LIB', text: 'Libanon', idArea: '5',
},
{
	id: '23', value: 'LIE', text: 'Liechtenstein', idArea: '1',
},
{
	id: '210', value: 'LTU', text: 'Litauen', idArea: '1',
},
{
	id: '209', value: 'LUX', text: 'Luxembourg', idArea: '1',
},
{
	id: '302', value: 'MAC', text: 'Macao', idArea: '5',
},
{
	id: '196', value: 'MAD', text: 'Madagaskar', idArea: '4',
},
{
	id: '17', value: 'MAR', text: 'Marokko', idArea: '4',
},
{
	id: '216', value: 'MAS', text: 'Malaysia', idArea: '5',
},
{
	id: '206', value: 'MAW', text: 'Malawi', idArea: '4',
},
{
	id: '198', value: 'MDA', text: 'Moldavien', idArea: '1',
},
{
	id: '204', value: 'MDV', text: 'Malediven', idArea: '5',
},
{
	id: '200', value: 'MEX', text: 'Mexico', idArea: '2',
},
{
	id: '205', value: 'MGL', text: 'Mongolei', idArea: '5',
},
{
	id: '306', value: 'MHL', text: 'Marshallinseln', idArea: '6',
},
{
	id: '208', value: 'MKD', text: 'Nordmazedonien', idArea: '1',
},
{
	id: '203', value: 'MLI', text: 'Mali', idArea: '4',
},
{
	id: '202', value: 'MLT', text: 'Malta', idArea: '1',
},
{
	id: '11', value: 'MNE', text: 'Montenegro', idArea: '1',
},
{
	id: '197', value: 'MON', text: 'Monaco', idArea: '1',
},
{
	id: '225', value: 'MOZ', text: 'Mosambik', idArea: '4',
},
{
	id: '47', value: 'MRI', text: 'Mauritius', idArea: '4',
},
{
	id: '201', value: 'MTN', text: 'Mauritanien', idArea: '4',
},
{
	id: '235', value: 'MYA', text: 'Myanmar (Burma)', idArea: '5',
},
{
	id: '234', value: 'NAM', text: 'Namibia', idArea: '4',
},
{
	id: '229', value: 'NCA', text: 'Nikaragua', idArea: '2',
},
{
	id: '44', value: 'NED', text: 'Niederlande', idArea: '1',
},
{
	id: '232', value: 'NEP', text: 'Nepal', idArea: '5',
},
{
	id: '7', value: 'NGR', text: 'Nigeria', idArea: '4',
},
{
	id: '228', value: 'NIG', text: 'Niger', idArea: '4',
},
{
	id: '0', value: 'NN', text: 'unbekannt', idArea: '0',
},
{
	id: '227', value: 'NOR', text: 'Norwegen', idArea: '1',
},
{
	id: '233', value: 'NRU', text: 'Nauru', idArea: '6',
},
{
	id: '230', value: 'NZL', text: 'Neuseeland', idArea: '6',
},
{
	id: '217', value: 'OMA', text: 'Oman', idArea: '5',
},
{
	id: '226', value: 'PAK', text: 'Pakistan', idArea: '5',
},
{
	id: '223', value: 'PAN', text: 'Panama', idArea: '3',
},
{
	id: '221', value: 'PAR', text: 'Paraguay', idArea: '3',
},
{
	id: '220', value: 'PER', text: 'Peru', idArea: '3',
},
{
	id: '219', value: 'PHI', text: 'Philippinen', idArea: '5',
},
{
	id: '224', value: 'PLE', text: 'Palestina', idArea: '5',
},
{
	id: '236', value: 'PLW', text: 'Palau', idArea: '6',
},
{
	id: '222', value: 'PNG', text: 'Papua New Guinea', idArea: '6',
},
{
	id: '22', value: 'POL', text: 'Polen', idArea: '1',
},
{
	id: '218', value: 'POR', text: 'Portugal', idArea: '1',
},
{
	id: '96', value: 'PRK', text: 'Nord Korea', idArea: '5',
},
{
	id: '213', value: 'PUR', text: 'Puerto Rico', idArea: '2',
},
{
	id: '163', value: 'QAT', text: 'Qatar', idArea: '5',
},
{
	id: '68', value: 'ROU', text: 'Rumänien', idArea: '1',
},
{
	id: '73', value: 'RSA', text: 'Republik Südafrika', idArea: '4',
},
{
	id: '35', value: 'RUS', text: 'Russland', idArea: '1',
},
{
	id: '173', value: 'RWA', text: 'Ruanda', idArea: '4',
},
{
	id: '169', value: 'SAM', text: 'Samoa', idArea: '6',
},
{
	id: '155', value: 'SEN', text: 'Senegal', idArea: '4',
},
{
	id: '164', value: 'SEY', text: 'Seychellen', idArea: '5',
},
{
	id: '162', value: 'SGP', text: 'Singapur', idArea: '5',
},
{
	id: '172', value: 'SKN', text: 'St. Kitts und Nevis', idArea: '2',
},
{
	id: '174', value: 'SLE', text: 'Sierra Leone', idArea: '4',
},
{
	id: '4', value: 'SLO', text: 'Slowenien', idArea: '1',
},
{
	id: '168', value: 'SMR', text: 'San Marino', idArea: '1',
},
{
	id: '161', value: 'SOL', text: 'Salomonen', idArea: '6',
},
{
	id: '160', value: 'SOM', text: 'Somalia', idArea: '4',
},
{
	id: '296', value: 'SRB', text: 'Serbien', idArea: '1',
},
{
	id: '158', value: 'SRI', text: 'Sri Lanka', idArea: '5',
},
{
	id: '307', value: 'SSD', text: 'Südsudan', idArea: '4',
},
{
	id: '167', value: 'STP', text: 'Sao Tome und Principe', idArea: '2',
},
{
	id: '157', value: 'SUD', text: 'Sudan', idArea: '4',
},
{
	id: '3', value: 'SUI', text: 'Schweiz', idArea: '1',
},
{
	id: '194', value: 'SUR', text: 'Surinam', idArea: '3',
},
{
	id: '53', value: 'SVK', text: 'Slovakei', idArea: '1',
},
{
	id: '45', value: 'SWE', text: 'Schweden', idArea: '1',
},
{
	id: '184', value: 'SWZ', text: 'Swasiland', idArea: '4',
},
{
	id: '64', value: 'SYR', text: 'Syrien', idArea: '5',
},
{
	id: '193', value: 'TAN', text: 'Tansania', idArea: '4',
},
{
	id: '190', value: 'TGA', text: 'Tonga', idArea: '2',
},
{
	id: '192', value: 'THA', text: 'Thailand', idArea: '5',
},
{
	id: '165', value: 'TJK', text: 'Tadschikistan', idArea: '5',
},
{
	id: '187', value: 'TKM', text: 'Turkmenistan', idArea: '6',
},
{
	id: '303', value: 'TLS', text: 'Ost Timor', idArea: '5',
},
{
	id: '191', value: 'TOG', text: 'Togo', idArea: '4',
},
{
	id: '215', value: 'TPE', text: 'Republik China auf Taiwan', idArea: '5',
},
{
	id: '189', value: 'TTO', text: 'Trinidad und Tobago', idArea: '4',
},
{
	id: '188', value: 'TUN', text: 'Tunisien', idArea: '4',
},
{
	id: '12', value: 'TUR', text: 'Türkei', idArea: '1',
},
{
	id: '308', value: 'TUV', text: 'Tuvalu', idArea: '6',
},
{
	id: '185', value: 'UAE', text: 'Vereinige Arabische Emirate', idArea: '5',
},
{
	id: '175', value: 'UGA', text: 'Uganda', idArea: '4',
},
{
	id: '66', value: 'UKR', text: 'Ukraine', idArea: '1',
},
{
	id: '183', value: 'URU', text: 'Uruguay', idArea: '3',
},
{
	id: '40', value: 'USA', text: 'Vereinigte Staaten von Amerika', idArea: '2',
},
{
	id: '182', value: 'UZB', text: 'Usbekistan', idArea: '1',
},
{
	id: '181', value: 'VAN', text: 'Vanuatu', idArea: '6',
},
{
	id: '180', value: 'VEN', text: 'Venezuela', idArea: '3',
},
{
	id: '179', value: 'VIE', text: 'Vietnam', idArea: '5',
},
{
	id: '170', value: 'VIN', text: 'St. Vincent und die Grenadinen', idArea: '2',
},
{
	id: '177', value: 'YEM', text: 'Jemen', idArea: '5',
},
{
	id: '176', value: 'ZAM', text: 'Sambia', idArea: '4',
},
{
	id: '111', value: 'ZIM', text: 'Simbabwe', idArea: '4',
},
];

let done = false;

function getIOC() {
	if (!done) {
		done = true;
		ioc.forEach((x) => {
			x.text = `${x.text} (${x.value})`;
		});
	}
	return ioc;
}

export default getIOC;
